export class FetchApplicationData {
    public static readonly type = '[Application] FetchApplicationData';
}

export class SetSelectedApplicationId {
    public static readonly type = '[Application] SetSelectedApplicationId';
    constructor(public applicationId: string) {}
}
